import React, { useState } from 'react';
import { Plus, Minus, HelpCircle } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿POR QUÉ NADA TE HABÍA FUNCIONADO?',
    answer: <div className="space-y-4" data-id="element-651">
          <ul className="space-y-2" data-id="element-652">
            <li className="flex items-start gap-2 text-gray-700" data-id="element-653">
              <span className="text-rose-600 font-bold" data-id="element-654">•</span> Cambiar de
              concentrado no arregla el problema
            </li>
            <li className="flex items-start gap-2 text-gray-700" data-id="element-655">
              <span className="text-rose-600 font-bold" data-id="element-656">•</span> Los
              medicamentos solo tapan síntomas
            </li>
            <li className="flex items-start gap-2 text-gray-700" data-id="element-657">
              <span className="text-rose-600 font-bold" data-id="element-658">•</span> Las vitaminas
              solas no solucionan la causa
            </li>
            <li className="flex items-start gap-2 text-gray-700" data-id="element-659">
              <span className="text-rose-600 font-bold" data-id="element-660">•</span> Esperar solo
              empeora la inflamación
            </li>
          </ul>
          <p className="font-bold text-gray-900" data-id="element-661">
            👉 La raíz siempre es la misma: El cuerpo del perro está inflamado
            por dentro.
          </p>
          <p className="text-gray-700" data-id="element-662">
            Y la forma real de ayudarlo es alimentarlo bien todos los días. Eso
            es exactamente lo que hacen las 30 recetas naturales.
          </p>
        </div>
  }, {
    question: '¿Necesito ser experto en cocina?',
    answer: 'Para nada. Las recetas están diseñadas para ser extremadamente sencillas. Si sabes hervir agua y cortar ingredientes, puedes hacerlas. Además, incluimos una guía paso a paso.'
  }, {
    question: '¿Es seguro para cualquier raza?',
    answer: 'Sí, las recetas utilizan ingredientes naturales aptos para perros. Sin embargo, si tu perro tiene una condición médica específica diagnosticada (como insuficiencia renal grave), siempre recomendamos consultar con tu veterinario antes de hacer cambios drásticos.'
  }, {
    question: '¿Cómo accedo al material?',
    answer: 'Inmediatamente después de tu pago, recibirás un correo electrónico con los enlaces de descarga. Es un producto 100% digital, así que no tienes que esperar envíos físicos.'
  }];
  return <section className="py-10 bg-white" data-id="element-663">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-664">
        <div className="text-center mb-8" data-id="element-665">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-100 text-amber-700 rounded-full mb-6" data-id="element-666">
            <HelpCircle className="w-8 h-8" data-id="element-667" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-668">
            Preguntas Frecuentes
          </h2>
          <p className="text-gray-600" data-id="element-669">
            Resolvemos tus dudas para que tomes la mejor decisión para tu perro.
          </p>
        </div>

        <div className="space-y-4" data-id="element-670">
          {faqs.map((faq, idx) => <div key={idx} className="border border-gray-200 rounded-xl overflow-hidden hover:border-amber-200 transition-colors" data-id="element-671">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-672">
                <span className="font-bold text-gray-900 text-lg pr-8" data-id="element-673">
                  {faq.question}
                </span>
                {openIndex === idx ? <Minus className="w-5 h-5 text-amber-600 flex-shrink-0" data-id="element-674" /> : <Plus className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-675" />}
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-676">
                <div className="p-6 pt-0 text-gray-600 bg-white border-t border-gray-100" data-id="element-677">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}